<!-- Banner -->
<!-- <img src="/assets/img/listing-page-banner.png" class="img-fluid w-100" alt="img" /> -->
<div class="container-fluid mt-3">
  <div class="row column-mobile-reverse">
    <div class="col-md-5">
      <app-new-products></app-new-products>
    </div>
    <div class="col-md-7">
      <div class="d-flex justify-content-md-end sort-by-responsive">
        <ul class="list-inline mb-0 d-inline-flex align-items-center d-flex">
          <li class="list-inline-item f-small ml-xl-3 text-uppercase">
            View
          </li>

          <li class="list-inline-item">
            <div class="form-group mb-0 pos">
              <select class="form-control dr-list new-select-box" id="sel1" (change)="changePerPage($event)">
                <option value="30" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 30">30 items
                </option>
                <option value="50" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 50">50 items
                </option>
                <option value="100" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 100">100
                  items</option>
                <option value="500" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 500">500
                  items</option>
              </select>
            </div>
          </li>
          <li class="list-inline-item f-small ml-xl-4 text-uppercase">
            Sort By:
          </li>
          <li class="list-inline-item">
            <div class="form-group mb-0">
              <select class="form-control dr-list new-select-box" id="sel1" (change)="sortBy($event)">
                <option value="price_low_to_high"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_low_to_high'">Price low
                  to high</option>
                <option value="price_high_to_low"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_high_to_low'">Price high
                  to low</option>
                <option value="weight_low_to_high"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'weight_low_to_high'">Weight
                  Low
                  to High</option>
                <option value="weight_high_to_low"
                  [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'weight_high_to_low'">Weight
                  High
                  to Low</option>
              </select>
            </div>
          </li>

          <li class="ml-xl-4">
            <a (click)="downloadAsPDF()" style="cursor: pointer;">
              <img src="/assets/img/download-icon.svg" alt="Download" width="30px" />
            </a>
          </li>

          <li class="ml-xl-4 grid-icon-style">
            <a class="cp" *ngIf="!showFirstIcon" (click)="toggleIcon()">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M14 5.6C14 5.03995 14 4.75992 14.109 4.54601C14.2049 4.35785 14.3578 4.20487 14.546 4.10899C14.7599 4 15.0399 4 15.6 4H18.4C18.9601 4 19.2401 4 19.454 4.10899C19.6422 4.20487 19.7951 4.35785 19.891 4.54601C20 4.75992 20 5.03995 20 5.6V8.4C20 8.96005 20 9.24008 19.891 9.45399C19.7951 9.64215 19.6422 9.79513 19.454 9.89101C19.2401 10 18.9601 10 18.4 10H15.6C15.0399 10 14.7599 10 14.546 9.89101C14.3578 9.79513 14.2049 9.64215 14.109 9.45399C14 9.24008 14 8.96005 14 8.4V5.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path
                    d="M4 5.6C4 5.03995 4 4.75992 4.10899 4.54601C4.20487 4.35785 4.35785 4.20487 4.54601 4.10899C4.75992 4 5.03995 4 5.6 4H8.4C8.96005 4 9.24008 4 9.45399 4.10899C9.64215 4.20487 9.79513 4.35785 9.89101 4.54601C10 4.75992 10 5.03995 10 5.6V8.4C10 8.96005 10 9.24008 9.89101 9.45399C9.79513 9.64215 9.64215 9.79513 9.45399 9.89101C9.24008 10 8.96005 10 8.4 10H5.6C5.03995 10 4.75992 10 4.54601 9.89101C4.35785 9.79513 4.20487 9.64215 4.10899 9.45399C4 9.24008 4 8.96005 4 8.4V5.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path
                    d="M4 15.6C4 15.0399 4 14.7599 4.10899 14.546C4.20487 14.3578 4.35785 14.2049 4.54601 14.109C4.75992 14 5.03995 14 5.6 14H8.4C8.96005 14 9.24008 14 9.45399 14.109C9.64215 14.2049 9.79513 14.3578 9.89101 14.546C10 14.7599 10 15.0399 10 15.6V18.4C10 18.9601 10 19.2401 9.89101 19.454C9.79513 19.6422 9.64215 19.7951 9.45399 19.891C9.24008 20 8.96005 20 8.4 20H5.6C5.03995 20 4.75992 20 4.54601 19.891C4.35785 19.7951 4.20487 19.6422 4.10899 19.454C4 19.2401 4 18.9601 4 18.4V15.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path
                    d="M14 15.6C14 15.0399 14 14.7599 14.109 14.546C14.2049 14.3578 14.3578 14.2049 14.546 14.109C14.7599 14 15.0399 14 15.6 14H18.4C18.9601 14 19.2401 14 19.454 14.109C19.6422 14.2049 19.7951 14.3578 19.891 14.546C20 14.7599 20 15.0399 20 15.6V18.4C20 18.9601 20 19.2401 19.891 19.454C19.7951 19.6422 19.6422 19.7951 19.454 19.891C19.2401 20 18.9601 20 18.4 20H15.6C15.0399 20 14.7599 20 14.546 19.891C14.3578 19.7951 14.2049 19.6422 14.109 19.454C14 19.2401 14 18.9601 14 18.4V15.6Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </a>
            <a class="cp" *ngIf="showFirstIcon" (click)="toggleIcon()">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M8 6.00067L21 6.00139M8 12.0007L21 12.0015M8 18.0007L21 18.0015M3.5 6H3.51M3.5 12H3.51M3.5 18H3.51M4 6C4 6.27614 3.77614 6.5 3.5 6.5C3.22386 6.5 3 6.27614 3 6C3 5.72386 3.22386 5.5 3.5 5.5C3.77614 5.5 4 5.72386 4 6ZM4 12C4 12.2761 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.2761 3 12C3 11.7239 3.22386 11.5 3.5 11.5C3.77614 11.5 4 11.7239 4 12ZM4 18C4 18.2761 3.77614 18.5 3.5 18.5C3.22386 18.5 3 18.2761 3 18C3 17.7239 3.22386 17.5 3.5 17.5C3.77614 17.5 4 17.7239 4 18Z"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </a>
          </li>

        </ul>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="pbb-line"></div>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between mt-2">
    <p></p>
    <span style="text-decoration: underline;" class="mb-2 mb-md-0"> Showing {{per_page}} items</span>
  </div>
</div>
<!-- <app-wheel-heading [title]="'Wheel for ' + year + ' ' + (make | uppercase) + ' ' + (model | uppercase) " *ngIf="year && make && model"></app-wheel-heading> -->


<!--  -->
<section class="mt-3 mb-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-wheel-filters [showFilters]="showFilters" [filters]="filters" (filterSelected)="onFilterSelections($event)"
          (onClear)="onClear($event)" [diameter]="diameter" (onhideFilters)="onhideFilters()"
          [searchVehiclehome]="serchvehiclehome"></app-wheel-filters>
      </div>
      <div class="col-md-9 border-left-filter">
        <!--        <app-preloader *ngIf="loadProducts"></app-preloader>-->
        <div class="row" *ngIf="!loadProducts">
          <div class="col-md-12 list-reviews-tab">
            <ul class="nav nav-tabs nav-justified search-nav-tabs" *ngIf="route.snapshot.url[0].path!='search-by-size'">
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == (+diameter - 1)" data-toggle="tab" href="#home"
                  (click)="getWheelsByDiameter(+diameter - 1)">{{+diameter - 1}}″(-1)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" [class.active]="activeDiameter == (diameter) || !activeDiameter"
                  data-toggle="tab" href="#menu1" (click)="getWheelsByDiameter(diameter)">{{diameter}}″(OEM)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == +diameter + 1" data-toggle="tab" href="#menu2"
                  (click)="getWheelsByDiameter(+diameter + 1)">{{+diameter + 1}}″(+1)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == +diameter + 2" data-toggle="tab" href="#menu3"
                  (click)="getWheelsByDiameter(+diameter + 2)">{{+diameter + 2}}″(+2)</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="activeDiameter == +diameter + 3" data-toggle="tab" href="#menu3"
                  (click)="getWheelsByDiameter(+diameter + 3)">{{+diameter + 3}}″(+3)</a>
              </li>
            </ul>
            <div class="tab-content list-reviews-tab-content listing-list">
              <div class="tab-pane  active" id="home">
                <div class="row f-light hide-small">
                  <!-- <div class="col-md-12">
                    <ul class="list-inline">
                      <li class="list-inline-item f-small">
                        Show {{ products?.length }} Wheels
                      </li>
                      <li class="list-inline-item f-small ml-xl-3">
                        Show
                      </li>
                      <li class="list-inline-item">
                        <div class="form-group">
                          <select class="form-control dr-list" id="sel1" (change)="changePerPage($event)">
                            <option value="30" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 30">30 items</option>
                            <option value="50" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 50">50 items</option>
                            <option value="100" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 100">100 items</option>
                            <option value="500" [selected]="queryParams && queryParams.perPage && queryParams.perPage == 500">500 items</option>
                          </select>
                        </div>
                      </li>
                      <li class="list-inline-item f-small ml-xl-5">
                        Sort By
                      </li>
                      <li class="list-inline-item">
                        <div class="form-group">
                          <select class="form-control dr-list" id="sel1" (change)="sortBy($event)">
                            <option value="price_low_to_high" [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_low_to_high'">Price low to high</option>
                            <option value="price_high_to_low" [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_high_to_low'">Price high to low</option>
                            <option value="brand" [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'brand'">Brand Name</option>
                          </select>
                        </div>
                      </li>
                    </ul>
                  </div> -->

                  <!-- <div class="col-md-12 col-lg-12 col-xl-4">
                    <div class="f-light" *ngIf="route.snapshot.url[0].path=='search-by-size' || route.snapshot.url[0].path=='serchvehicle'">
                    
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item f-small">
                          Show
                        </li>
                    
                    
                        <li class="list-inline-item f-small">
                          <div class="form-group">
                            <input type="checkbox" (change)="ShowHideWeightHub('w')">
                          </div>
                        </li>
                        <li class="list-inline-item f-small">
                          Weight
                        </li>
                    
                        <li class="list-inline-item f-small">
                          <div class="form-group">
                            <input type="checkbox" (change)="ShowHideWeightHub('h')">
                          </div>
                        </li>
                        <li class="list-inline-item f-small">
                          Hub Bore
                        </li>
                      </ul>
                    
                    </div>
                  </div> -->


                </div>


                

                <div class="row hide-large align-items-center mb-3"
                  *ngIf="route.snapshot.url[0].path=='search-by-size' || route.snapshot.url[0].path=='serchvehicle'">
                  
                </div>

                <ng-template [ngForOf]="products" let-product ngFor let-i="index">
                  <app-wheel-single [isRear]="isRear" [product]="product" [is_hide_cost]="is_hide_cost"
                    (onViewDetail)="onViewDetail($event)" [viewDetailLoader]="viewDetailLoader"></app-wheel-single>

                  <div class="d-flex flex-row align-items-center justify-content-end"
                    style="position: relative;z-index: 100;">
                    <button type="button" id="{{product.product_variant_id}}"
                      class="btn btn-02 f-large addcart ml-3 new-btn cart-btn text-uppercase"
                      *ngIf="checkInStock(product)" style="cursor:pointer"
                      (click)="onViewDetailSearchBySize(product)">
                      <span style="cursor:pointer">ADD TO CART</span>
                    </button>
                    <p *ngIf="!checkInStock(product)" class="text-danger">Out
                      of Stock</p>
                  </div>

                  <ng-template [ngIf]="i != products.length - 1">
                    <hr />
                  </ng-template>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="row text-center" *ngIf="!loadMoreProducts && hasNextPage && !loadProducts && products.length">
          <div class="col-12">
            <button type="button" class="btn btn-primary" (click)="loadMore()">Load More</button>
          </div>
        </div>
        <app-preloader *ngIf="loadMoreProducts"></app-preloader>
        <app-not-found *ngIf="noDataFound == true"></app-not-found>
      </div>
    </div>
  </div>
</section>

<!-- Single Wheel Detail Modal -->
<ng-template #content>
  <app-wheel-detail-modal-refactored [modal]="modalService" [checkfitment]="checkfitment" [product]="productDetail"
    [vehicle]="vehicle" [deliveryDate]="deliveryDate" [vehicleWheels]="vehicleWheels"
    [is_hide_cost]='is_hide_cost'></app-wheel-detail-modal-refactored>
</ng-template>

<div id="overlay" class="overlay" *ngIf="isDownloding">
  <div class="text-white text-center d-flex flex-column justify-content-center align-items-center">
    <h1>Downloding Products ...</h1>
    <img src="assets/img/new-loader.png" id="voyager-loader">
  </div>
</div>